/* eslint no-console:0 */
import Rails from "@rails/ujs";

import ReactMountHandler from "./utils/reactMountHandler";
import { application } from "./controllers/application";
import DateInputController from "./controllers/forms/date_input_controller";

import "@hotwired/turbo-rails";

import "./scripts/alerts";
import "./stylesheets/devise.css";

const componentRequireContext = require.context("components/inputs", true);

application.register("date-input", DateInputController);

ReactMountHandler(componentRequireContext);
Rails.start();
